import { render, staticRenderFns } from "./SideEffectLoading.vue?vue&type=template&id=7bbfbbe4"
import script from "./SideEffectLoading.vue?vue&type=script&lang=js"
export * from "./SideEffectLoading.vue?vue&type=script&lang=js"
import style0 from "./SideEffectLoading.vue?vue&type=style&index=0&id=7bbfbbe4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports